import type { RxJsonSchema } from 'rxdb'

export interface LabelGroupDocument {
  id: string
  envId: string
  projectId?: string | null
  name: string
  description?: string | null
  sortOrder?: string | null
  isDeleted: boolean

  createdOn: number
  createdBy: string
  updatedOn: number
  updatedBy: string
  deletedOn?: number | null
  deletedBy?: string | null
  updatedAt?: number
}

export const labelGroupSchema: RxJsonSchema<LabelGroupDocument> = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 36,
    },
    envId: {
      type: 'string',
      maxLength: 36,
    },
    projectId: {
      type: ['string', 'null'],
      maxLength: 36,
    },
    name: {
      type: 'string',
      maxLength: 100,
    },
    description: {
      type: ['string', 'null'],
      maxLength: 500,
    },
    sortOrder: {
      type: ['string', 'null'],
      maxLength: 50,
    },
    isDeleted: {
      type: 'boolean',
      default: false,
    },
    createdOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    createdBy: {
      type: 'string',
      maxLength: 36,
    },
    updatedOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    updatedBy: {
      type: 'string',
      maxLength: 36,
    },
    deletedOn: {
      type: ['number', 'null'],
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    deletedBy: {
      type: ['string', 'null'],
      maxLength: 36,
    },
    updatedAt: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
  },
  required: [
    'id',
    'envId',
    'name',
    'isDeleted',
    'createdOn',
    'createdBy',
    'updatedOn',
    'updatedBy',
  ],
  indexes: ['envId', ['envId', 'isDeleted']],
}
